import { useQuery } from "@tanstack/react-query";
import { BOUTIQUE_STANDARD_CACHE_CONFIG } from "@/features/boutique/constants";
import { boutiqueService } from "@/features/boutique/services/boutique.service";
import type { CataloguesResponse } from "@/features/boutique/types/catalogue.type";

type UseCataloguesOptions = { enabled?: boolean };

export const useCatalogues = (options?: UseCataloguesOptions) => {
  const { enabled = true } = options ?? {};

  const { data, isLoading, error } = useQuery<CataloguesResponse>({
    queryKey: ["catalogues"],
    queryFn: boutiqueService.getCatalogues,
    enabled,
    ...BOUTIQUE_STANDARD_CACHE_CONFIG,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    catalogues: enabled ? data?.catalogues ?? [] : [],
    isLoading: enabled ? isLoading : false,
    error,
  };
};
